// document ready
jQuery(document).ready(function ($) {

    // variables
    let $progess = $('#products-progress');
    let $updater = $('#run-product-updater');

    // load pricing table ajax function
    function load_updater_table(json_update= false) {

        // empty the product updater table
        $('.product-updater-results').empty();

        // jquery ajax call
        $.ajax({
            cache: false,
            timeout: 30000,
            url: admin_ajax_url,
            type: 'GET',
            data: {
                action          : 'load_updater_table',
                json_update     : json_update,
                count           : $progess.data('count')
            },
            success: function (data) {

                // remove processing class
                $updater.removeClass('processing');

                // on success render pricing table
                $('.product-updater-results').prepend(data);

                // if bulk update is true do stuff
                if(json_update === true) {

                }
            }
        });

    }

    // load all products
    load_updater_table();

    // product run updater button
    $updater.on('click',function() {

        // add processing class
        $(this).addClass('processing');

        // re run function
        load_updater_table(true);

    });

});